import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "iodine-icon-container" }

import { ref, Ref } from 'vue';
import { Dark } from 'quasar'

export interface Props {
  fullscreen?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperTitle',
  props: {
    fullscreen: { type: Boolean, default: false }
  },
  emits: ["fullscreen", "close"],
  setup(__props: any, { emit: __emit }) {


const darkModel: Ref<boolean> = ref(false)
const props = __props

const emit = __emit

const fullscreen: Ref<boolean> = ref(props.fullscreen)

const onClose = () => {
  console.log('Close Called...');
  emit('close')
}

const onModeChange = () => {
    console.log('Mode Changed');
    Dark.set(darkModel.value)
}


const onExpandCollapse = () => {
  console.log('Expand/Collapse Called...');
  fullscreen.value = !fullscreen.value;
  emit('fullscreen', fullscreen.value)
  return fullscreen.value;
};


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_bar = _resolveComponent("q-bar")!

  return (_openBlock(), _createBlock(_component_q_bar, { class: "title-bar" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_icon, {
          name: "fa-solid fa-layer-group",
          class: "iodine-small-icon"
        })
      ]),
      _createVNode(_component_q_toolbar_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Grouper")
        ]),
        _: 1
      }),
      _createVNode(_component_q_toggle, {
        "false-value": true,
        "true-value": false,
        color: "black",
        size: "xs",
        modelValue: darkModel.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((darkModel).value = $event)),
          onModeChange
        ]
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        class: "text-none iodine-icon-button",
        round: "",
        onClick: onExpandCollapse
      }, {
        default: _withCtx(() => [
          (fullscreen.value)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "fa-solid fa-compress",
                class: "iodine-small-icon"
              }))
            : (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "fa-solid fa-expand",
                class: "iodine-small-icon"
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        class: "text-none iodine-icon-button",
        round: "",
        onClick: onClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "fa-solid fa-xmark",
            class: "iodine-small-icon"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})